import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { WithIsHome, WithTeam } from '~/core/styleTypes';

export const ADVERTISEMENT_PLACEHOLDER = 320;

export const TopBar = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        padding-top: 32px;
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        padding-top: 0;
        margin-top: -20px;
    }
`;

export const MonthYear = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['20b']}

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['22b']}
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        ${BaseStyle.Mixins.fontStyles.ui['30b']}
        font-weight: 900;
    }

    @media print {
        position: fixed;
        top: 50px;
    }
`;

export const PromotionsContainer = styled.a`
    ${BaseStyle.Mixins.fontStyles.desktop.body3}
    display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
    width: 300px;
    height: 20px;
    color: ${({ theme }) => theme.Utility.cta};
    text-align: center;
    text-decoration-line: underline;
`;

export const ColorCodeContainer = styled.div`
    display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
    min-width: 140px;
    height: 20px;
    justify-content: space-between;

    ${BaseStyle.Mixins.screenSizes.large} {
        padding-right: ${ADVERTISEMENT_PLACEHOLDER}px; // we set this for large screensizes to account for the ad on the right hand side
    }

    @media print {
        display: flex;
        position: fixed;
        top: 50px;
        right: 0;
    }
`;

export const ColorGroup = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    min-width: 64px;
    margin-left: 8px;
    height: 20px;
    align-items: center;
`;

export const ColorBox = styled.div<WithIsHome & WithTeam>`
    min-width: 16px;
    height: 16px;
    border-radius: 2px;
    border: 2px solid
        ${({ theme, $isHome, $teamAbbrev }) =>
            $isHome && $teamAbbrev && theme.Team[$teamAbbrev] ? theme.Team[$teamAbbrev].primary : theme.Surface.border};
    background-color: ${({ $isHome, $teamAbbrev, theme }) =>
        $isHome && $teamAbbrev && theme.Team[$teamAbbrev] ? theme.Team[$teamAbbrev].primary : theme.Surface.primary};
`;

export const ColorType = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.body3}
    width: 100%;
    min-width: 40px;
    height: 20px;
    line-height: 20px;
`;

export const BottomControls = styled.div`
    ${BaseStyle.Mixins.gaps.large}
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;

    @media print {
        display: none;
    }
`;
